module.exports = __webpack_public_path__ + "r-v3/img/ico_arrowRight_gray.c0e39afa.svg";